// Shared reactive UI state for Swell overlays (drawer, group view, modals, toasts).
import { reactive } from "vue";
import { SwellService } from "../../services/swell.service";

let _tid = 0;

export const swell = reactive({
  // -- current user's Swell permissions (null until loaded; null perms = not a member) --
  perms: null,
  permsLoaded: false,
  async loadPerms() {
    const { data } = await SwellService.getMyPermissions();
    this.perms = data || null;
    this.permsLoaded = true;
    return this.perms;
  },
  isAdmin() {
    return !!(this.perms && this.perms.is_admin);
  },
  // can the current user access a given section?
  can(section) {
    const p = this.perms;
    if (!p) return false;
    if (p.is_admin) return true;
    switch (section) {
      case "leads": return p.leads !== "none";
      case "pipeline": return p.pipeline !== "none";
      case "insights": return !!p.insights;
      case "roster": return !!p.roster;
      case "contacts": return !!p.contacts;
      case "brands": return !!p.brands;
      case "discovery": return !!p.brands; // brand prospecting — reuse the Brands permission
      case "settings": return false; // admin-only
      default: return false;
    }
  },

  leadId: null, // lead detail drawer
  groupId: null, // group view (rendered in-place by LeadsView)
  pitchId: null, // quick-pitch modal
  kitId: null, // full pitch kit overlay
  lostId: null, // mark-as-lost modal (pipeline)
  contactId: null, // contact detail drawer
  rosterCreator: null, // roster creator detail drawer (holds the creator row)
  alertsOpen: false,
  toasts: [],

  // Bumped whenever a contact record changes (reveal, verify, add/move on Reach outs). Screens that
  // render contacts watch this and re-read — pulse_contact isn't on the realtime channel, so a
  // reveal in the lead drawer would otherwise leave the Reach outs table showing stale icons.
  contactsTick: 0,
  contactsChanged() { this.contactsTick++; },

  openContact(id) { this.contactId = id; },
  closeContact() { this.contactId = null; },

  openRosterCreator(handle) { this.rosterCreator = handle; },
  closeRosterCreator() { this.rosterCreator = null; },

  openLead(id) { this.leadId = id; },
  closeLead() { this.leadId = null; },
  openGroup(id) { this.groupId = id; this.leadId = null; },
  closeGroup() { this.groupId = null; },
  openPitch(id) { this.pitchId = id; },
  closePitch() { this.pitchId = null; },
  openKit(id) { this.kitId = id; this.leadId = null; },
  closeKit() { this.kitId = null; },
  openLost(id) { this.lostId = id; },
  closeLost() { this.lostId = null; },
  toggleAlerts() { this.alertsOpen = !this.alertsOpen; },

  toast(text, intent = "success") {
    const id = ++_tid;
    this.toasts.push({ id, text, intent });
    setTimeout(() => { this.toasts = this.toasts.filter((t) => t.id !== id); }, 3200);
  },
});
